import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import styles from "./styles.module.scss";
import Input from "../../../custom/input/input";
import { useQuery } from "@tanstack/react-query";
import { getNextOfKin } from "../../../requests";
import { useAtomValue } from "jotai";
import { userData } from "../../../state";
import { Spin } from "antd";
import { AxiosError } from "axios";
import { useState } from "react";
import Button from "../../../custom/button/button";
import classNames from "classnames";
import AddNextOfKinModal from "./addNextOfKinModal";

const NextOfKin = () => {
  const user = useAtomValue(userData);
  const [open, setOpen] = useState(false);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["next-of-kin"],
    queryFn: () => getNextOfKin(user?.MemberId!),
  });

  const nextOfKinData = data?.Data as NextOfKin[];

  const formik = useFormik<FormikValues>({
    initialValues: {
      fullName: "",
      email: "",
      phoneNumber: "",
      relationship: "",
      contactAddressLine1: "",
    },
    onSubmit: () => {},
    enableReinitialize: true,
  });

  if (isLoading) return <Spin />;
  if (isError) return <div>{(error as AxiosError)?.message}</div>;

  return (
    <div>
      <FormikProvider value={formik}>
        <Button
          className={classNames(styles.lightBtn, styles.end)}
          onClick={() => setOpen(true)}
          text="Add Next of Kin"
        />
        <form onSubmit={formik.handleSubmit} className={styles.form}>
          {nextOfKinData?.map((nextOfKin, index) => (
            <section className={styles.details} key={nextOfKin?.Id}>
              <h2 className={styles.heading}>NEXT OF KIN - {index + 1}</h2>
              <hr className={styles.hr} />
              <section className={styles.fields}>
                <Field
                  as={Input}
                  type="text"
                  name="fullName"
                  label="Full Name"
                  placeholder={nextOfKin?.FullName}
                  className={styles.input}
                  disabled={true}
                />
                <Field
                  as={Input}
                  type="email"
                  name="email"
                  label="Email Address"
                  placeholder={nextOfKin?.Email}
                  className={styles.input}
                  disabled={true}
                />
              </section>
              <section className={styles.fields}>
                <Field
                  as={Input}
                  type="text"
                  name="phoneNumber"
                  label="Phone Number"
                  placeholder={nextOfKin?.PhoneNumber}
                  className={styles.input}
                  disabled={true}
                />
                <Field
                  as={Input}
                  type="text"
                  name="relationship"
                  label="Relationship"
                  placeholder={nextOfKin?.Relationship}
                  className={styles.input}
                  disabled={true}
                />
              </section>

              <section className={styles.field}>
                <Field
                  as={Input}
                  type="text"
                  name="contactAddressLine1"
                  label="Contact Address"
                  placeholder={nextOfKin?.Address}
                  className={styles.input}
                  disabled={true}
                />
              </section>
            </section>
          ))}
        </form>
      </FormikProvider>
      <AddNextOfKinModal open={open} handleClose={() => setOpen(false)} />
    </div>
  );
};

export default NextOfKin;
